/** Joins CSS classes and skips empty values. */
export function cx(...classes) {
    return classes.filter(Boolean).join(' ');
}
//# sourceMappingURL=cx.js.map